<template>
  <v-container>
    <h2 class="mt-5 mb-6">{{$t('payroll_process')}}</h2>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-form v-model="valid" ref="formData">
        <v-card class="pa-0" color="#f1f7fb">
          <v-row class="ma-0">
            <v-col cols="12" class="pa-0">
              <v-card color="primary" dark tile class="pa-0">
                <v-card-title>{{$t('payroll_process')}}</v-card-title>
                <v-card-subtitle>{{dataItem.periodName}}</v-card-subtitle>
              </v-card>
              <v-card tile flat color="transparent">
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="12">
                      <v-text-field label="Period Typew" :value="translateType(dataItem.periodType)" readonly></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :label="$t('start_date')"
                        prepend-inner-icon="mdi-calendar"
                        v-model="dataItem.startDate"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                       :label="$t('end_date')"
                        prepend-inner-icon="mdi-calendar"
                        v-model="dataItem.endDate"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :label="$t('attendance_start')"
                        prepend-inner-icon="mdi-calendar"
                        v-model="dataItem.startDateAtt"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :label="$t('attendance_end')"
                        prepend-inner-icon="mdi-calendar"
                        v-model="dataItem.endDateAtt"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :label="$t('pay_date')"
                        prepend-inner-icon="mdi-calendar"
                        v-model="dataItem.paymentDate"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" class="pa-0">
              <v-card tile flat height="100%">
                <v-card-title>
                  <v-row>
                    <v-col>{{$t('selected_employee')}}</v-col>
                    <v-col class="text-right">
                      <v-btn color="primary" @click="showAddEmployee">{{$t('manage_employee')}}</v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="pb-0 pt-0">
                  <v-data-table
                    :loading="loading"
                    :headers="detailHeaders"
                    :items="dataItem.users"
                    item-key
                    :page="page"
                    @update:page="setPage($event)"
                    :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" 
                    disable-sort
                    :no-data-text="$t('no_data')"
                    height="400px"
                  >
                    <template v-slot:item.no="{ index }">
                      <span v-if="page==1">{{(index+1)}}</span>
                      <span v-else>{{(index+1) + ((page-1)*10)}}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        outlined
                        small
                        depressed
                        color="primary"
                        @click="showSalaryDialog(item)"
                      >{{$t('see_details')}}</v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="mx-6 pb-6">
                  <v-row>
                    <v-col cols="12" class="d-flex justify-space-between">
                      <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
                      <v-btn
                        :loading="loading"
                        color="primary"
                        :disabled="!valid"
                        @click="saveComponent({usersId:selectedUser, periodId: dataItem.id, includeTax: false})"
                      >{{$t('process')}}</v-btn>
                      <v-btn color="success" @click="viewSummary(dataItem.id)">{{$t('show_summary')}}</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="addEmployeeDialog" max-width="550px">
      <v-card class="mx-auto">
        <v-card-title class="white--text primary">
          {{$t('manage_employee')}}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-list two-line>
          <v-virtual-scroll :items="userList" :item-height="64" height="300">
            <template v-slot:default="{ item }">
              <v-list-item-group multiple v-model="selectedUser">
                <v-list-item :key="item.title" :value="item.id">
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="1">
                          <v-btn icon v-if="!active">
                            <v-icon>mdi-checkbox-blank-outline</v-icon>
                          </v-btn>
                          <v-btn icon v-if="active" color="primary">
                            <v-icon>mdi-checkbox-marked</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col>
                          <v-list-item-title v-text="item.full_name" class="text--primary"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </template>
          </v-virtual-scroll>
        </v-list>
        <v-card-actions class="mx-6 pb-6">
          <v-row>
            <v-btn color="primary" text @click="closeAddUser">{{$t('cancel')}}</v-btn>
            <v-btn
              :loading="loading"
              color="primary"
              @click="saveSelectUser"
              :disabled="!valid"
            >{{$t('save')}}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="salaryDialog" max-width="1000px">
      <v-card class="mh-65 pa-0 ma-0" tile flat>
        <v-card-text>
          <salaries
            v-if="salaryDialog"
            v-bind:userId="selectedUserId"
            v-bind:loadData="true"
            v-bind:disableAdd="true"
            v-bind:showCloseButton="true"
            @close="salaryDialog = false"
          ></salaries>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="px-6 pb-0 mb-3">
      <v-card-text>
        <v-row>
          <v-col md="6" class="pt-0 pb-2">
            <v-text-field
              :rules="[validator.alfaNumberNotRequired]"
              :label="$t('search')"
              prepend-inner-icon="mdi-magnify"
              single-line
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col class="pt-0 pb-2">
            <div class="mt-4 float-right">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="onYearChange('prev')">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('previous_year')}}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="onYearChange('today')">
                    <v-icon>mdi-calendar</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('this_year')}}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="onYearChange('next')">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('next_year')}}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="search"
          :items="dataList"
          :headers="headers"
          class="elevation-1 mt-3"
          :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" 
        >
        <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
          <template v-slot:item.status="{ item }">
            <div v-if="item.status == 2">
              <v-chip color="success">{{$t('generated')}}</v-chip>
            </div>
            <div v-else-if="item.status == 1">
              <v-chip color="primary lighten-2">{{$t('processed')}}</v-chip>
            </div>
            <div v-else>
              <v-chip color="warning lighten-2">{{$t('draft')}}</v-chip>
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <span>
              <!-- <v-btn outlined small depressed color="primary" @click="editedItem(item)">See Detail</v-btn> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="primary" class="ml-1" small @click="editedItem(item)" v-if="item.status <= 1">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('edit')}}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="primary" class="ml-1" small v-if="item.status == 2">
                    <v-icon disabled>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('cannot_edit')}}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="success" class="ml-1" small @click="editedItem(item)" v-if="item.status == 2">
                    <v-icon>mdi-file-excel</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('report')}}</span>
              </v-tooltip>
              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon class="ml-1" small v-if="item.status <= 1">
                    <v-icon disabled>mdi-file-excel</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('report_not')}}</span>
              </v-tooltip>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>

<script>
import moment from "moment";
import Salaries from './Salaries.vue';
export default {
  name: "PayrollProcess",
  components: {
    Salaries
  },
  data() {
    return {
      selectedUserId: '',
      selectedUser: [],
      salaryDialog: false,
      addEmployeeDialog: false,
      isEdit: false,
      dialog: false,
      typeComponent: [],
      dataList: [],
      taxList: [],
      headers: [
        { text: this.$i18n.t('period'), value: "periodName" },
        { text: this.$i18n.t('pay_date'), value: "paymentDate" },
        { text: this.$i18n.t('total_employee'), value: "totalEmployee" },
        { text: this.$i18n.t('status'), value: "status" },
        { text: "Action", value: "action" },
      ],
      detailHeaders: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('name'), value: "fullName" },
        { text: this.$i18n.t('position'), value: "position" },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      page: 1,
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      dataItem: {
        id: 0,
        name: "",
        formula: "",
        status: false,
        type: '',
        componentCode: null,
        taxable: false,
        taxParameterId: null
      },
      search: "",
      editedIndex: -1,
      valid: true,
      valid2: true,
      date: new Date().toISOString().substr(0, 10),
      rules: [(v) => !!v || this.$i18n.t('required')],
      rules3: [(v) => !!v || this.$i18n.t('required'), (v) => (v ? v.length <= 5 : false) || 'Max 5 Char'],
      rules5: [(value) => (value ? value.length == 0 ? false || this.$i18n.t('required') : true : false || this.$i18n.t('required'))],
      loading: false,
      userList: [],
      year: moment().format('YYYY'),
      inProggress: false,



    };
  },
  methods: {
    translateType(type){
      switch (type) {
        case 1: return 'Payroll'
        case 2: return 'Bonus'
        case 3: return 'THR'
      }
    },
    showSalaryDialog(item) {
      this.selectedUserId = item.userId
      this.salaryDialog = true
      return true
    },
    async saveSelectUser() {
      // const data = this.userList.reduce((filtered, item) => {
      //   if (item) {
      //     const user = this.selectedUser.find(e => { return e == item.id })
      //     if (user) {
      //       filtered.push({
      //         userId: item.id,
      //         postition: item.job_postition,
      //         fullName: item.full_name
      //       })
      //     }
      //   }
      //   return filtered
      // }, [])
      // this.dataItem.users = data
      // eslint-disable-next-line no-console
      await this.saveSelectedEmployee({ periodId: this.dataItem.id, users: this.selectedUser })
      this.addEmployeeDialog = false
      await this.editedItem({ periodId: this.dataItem.id })
      this.dataList = await this.getComponent(this.year)
    },
    async onYearChange(type) {
      if (!this.inProggress) {
        switch (type) {
          case 'next':
            this.year++
            break
          case 'prev':
            this.year--
            break
          default:
            this.year = moment().format('YYYY')
            break
        }
        this.inProggress = true
        this.dataList = await this.getComponent(this.year)
        this.inProggress = false
      } else {
        this.showMessage('Proccessing please wait.', 'info')
      }
    },
    reselectEmployee() {
      this.selectedUser = []
      if (this.dataItem.users) this.dataItem.users.map(item => {
        this.selectedUser.push(item.userId)
      })
    },
    showAddEmployee() {
      this.reselectEmployee()
      this.addEmployeeDialog = true
    },
    setPage(page) {
      this.page = page
    },
    costumHeader(action, actionId) {
      return {
        headers: {
          action,
          actionId
        }
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async getComponent(year) {
      return await this.$store.dispatch('getPayrollPeriod', { year })
    },
    async getDetail(periodId) {
      return await this.$store.dispatch('getPayrollPeriodDetail', { periodId })
    },
    async saveSelectedEmployee(data) {
      const body = { periodId: data.periodId, users: data.users }
      this.loading = true
      const result = await this.$store.dispatch('savePayrollUsers', body)
      this.loading = false
      return result
    },
    async saveComponent(body) {
      this.loading = true
      const result = await this.$store.dispatch('savePayrollProcess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.viewSummary(body.periodId)
        // this.dialog = false
      }
    },
    viewSummary(periodId) {
      this.$store.dispatch('setPeriodId', periodId)
      this.$router.push({ name: "payroll-summary" });
    },
    dateFormatted(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    addItem() {
      this.isEdit = false
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    closeAddUser() {
      this.addEmployeeDialog = false
    },
    getPeriodType(type) {
      switch (type) {
        case 1: return 'Payroll'
        case 2: return 'Bonus'
        case 3: return 'THR'
      }
    },
    async editedItem(item) {
      this.$store.dispatch('setPeriodId', item.periodId)
      this.$router.push({ name: "payroll-summary" })
      // const data = await this.getDetail(item.periodId)
      // this.isEdit = true
      // this.dataItem = Object.assign({}, data);
      // this.dataItem.periodType = this.getPeriodType(this.dataItem.periodType)
      // this.reselectEmployee()
      // this.dialog = true
    },
  },
  async created() {
    this.dataList = await this.getComponent(this.year)
  },
  watch: {
    dialog(show) {
      if (show && !this.isEdit) {
        if (this.$refs.formData) {
          this.$refs.formData.reset()
          this.dataItem = {
            id: 0,
            name: "",
            formula: "",
            status: false,
            type: '',
            componentCode: null,
            taxable: false,
            taxParameterId: null
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.mh-65 {
  min-height: 65vh;
}
</style>